<!-- Global component for all -->

<router-outlet></router-outlet>

<!-- Global component for all -->
